import React from 'react'
import GalleryStyles from './Gallery.module.css'
import { Box, Button, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import IconButton from '@mui/material/IconButton';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import { useState } from 'react';
import axios from 'axios';
import { useEffect } from 'react';
// import this for redux read write
import { useSelector, useDispatch } from 'react-redux'
import { setNotifications } from '../../state/GlobalState'
import { setNotificationCount } from '../../state/GlobalState'

import useToast from '../../hooks/useToast';
import useBackdrop from '../../hooks/useBackdrop/useBackdrop';
import DeleteConformation from '../DeleteConformation/DeleteConformation';

const Gallery = () => {
    // get data from redux
    const name = useSelector((state) => state.globalData.name);
    const count = useSelector((state) => state.globalData.notificationCount);
    const dispatch = useDispatch()
    const [tempData, setTempData] = useState(null);
    const { Toast, showToast } = useToast();
    const { openBackdrop, closeBackdrop, BackdropComponent } = useBackdrop();


    const [data, setData] = useState([])

    const getGalleryData = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_COSMOSADMIN}/gallery/getAllImages`
            )
            setData(res.data)
            console.log(res.data)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getGalleryData()
    }, [])



    const deleteImagebyId = async () => {
        try {
            const res = await axios.delete(
                `${process.env.REACT_APP_COSMOSADMIN}/gallery/deleteById/${tempData.imageId}`
            ).then((res) => {
                showToast("success", "Image Delete Successfully");
                handleDeleteModal();
                getGalleryData();
            })

            

            dispatch(setNotificationCount({
                count: count + 1,
            }))

        } catch (error) {
            console.log(error)
        }
    }


    const [deleteModal, setDeleteModal] = useState(false);

    const handleDeleteModal = (data) => {
        setDeleteModal(prev => !prev)
        if (data !== undefined && data !== "" && data !== null) {
            setTempData(data)
        }
    }



    return (
        <>
            <Toast />
            <useBackdrop />
            <div className={GalleryStyles.galleryMain}>
                <div className={GalleryStyles.galleryContent}>
                    <div className={GalleryStyles.galleryHeader}>
                        <Typography sx={{ marginTop: '1%', color: '#121926', fontWeight: '600', fontSize: '20px' }} >
                            Gallery
                        </Typography>
                        <Link to='/addgallery'>
                            <Button sx={{ textTransform: 'capitalize' }} variant='contained'>Add Image</Button>
                        </Link>
                    </div>
                    <Box className={GalleryStyles.galleryComponent}>
                        <div className={GalleryStyles.galleryComponentLeft}>
                            <Typography variant='h5' sx={{ fontSize: '15px', fontWeight: '600' }}>
                                Name
                            </Typography>
                        </div>
                        <div className={GalleryStyles.galleryComponentRight}>
                            <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600' }}>
                                Last modified
                            </Typography>
                            <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600' }}>
                                Action
                            </Typography>
                        </div>
                    </Box>
                    {data.map((image) =>
                        <Box className={GalleryStyles.galleryComponent}>
                            <div className={GalleryStyles.galleryComponentLeft}>
                                <Typography variant='h5' sx={{ fontSize: '15px', fontWeight: '600' }}>
                                    {image.imageName}
                                </Typography>
                            </div>
                            <div className={GalleryStyles.galleryComponentRight}>
                                <Typography variant='h6' sx={{ fontSize: '15px' }}>
                                    {image.date}
                                </Typography>
                                <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600', display: 'flex', alignItems: 'baseline' }}>
                                    <Link to={`/editgallery/${image?.imageId}`} state={image}>
                                        <BorderColorOutlinedIcon sx={{ color: '#16469d', cursor: 'pointer' }} />
                                    </Link>
                                    <IconButton disableRipple onClick={() => handleDeleteModal(image)}>
                                        <DeleteForeverOutlinedIcon sx={{ color: '#16469d', cursor: 'pointer' }} />
                                    </IconButton>
                                </Typography>
                            </div>
                        </Box>
                    ).reverse()}
                </div>
            </div>



            <DeleteConformation
                onClose={handleDeleteModal}
                open={deleteModal}
                onConfirm={() => deleteImagebyId()}
                onReject={() => { }}
            >
                <h2>Delete Image</h2>
                <p>Are you sure you want to Delete this Image?</p>

            </DeleteConformation>
        </>
    )
}

export default Gallery